import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export const MeetDiv = styled.div`
  display: flex;
  width: calc(100% - 52px);
  height: 100%;
  justify-content: center;
  align-items: center;

  #meet {
    width: 100%;
    height: 100%;
  }

  iframe {
    width: 100% !important;
    height: 100% !important;
  }
`;
